
import React, { useState } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer';
import Sidebar from '../Sidebar/Sidebar';
import { Outlet } from 'react-router-dom';

const Layout = ({ hideSidebar }) => {
    const [isSidebarOpen, setSidebarOpen] = useState(false); // Sidebar state

    const toggleSidebar = () => {
        setSidebarOpen(!isSidebarOpen); // Toggle between true/false
    };
    return (
        <div className="app-layout min-h-screen flex bg-black">
            {/* ✅ Removed overlay backdrop - no more shade/fade effect */}
            
            <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar}/>
            <div className={`flex-1 flex flex-col bg-black transition-all duration-300 ease-in-out ${isSidebarOpen ? 'ml-[250px]' : 'ml-0'}`}>
                <Navbar toggleSidebar={toggleSidebar} />
                <div className="content flex-1 min-h-0 bg-black">
                    <Outlet />
                </div>
                <Footer />
            </div>
        </div>
    );
};


export default Layout;
